import React from "react";
import Hero from "./components/Hero";
import WhatIsCBR from "./components/WhatIsCBR";
import ChallengerCard from "./components/ChallengerCard";
import CourseTopics from "./components/CourseTopics";
import SpiritualDisciplines from "./components/SpiritualDisciplines";
import CBRFormat from "./components/CBRFormat";
import HowToConvene from "./components/HowToConvene";

const CBRProgramPage: React.FC = () => {
  return (
    <div className="w-full relative overflow-hidden bg-white">
      <Hero />
      <WhatIsCBR />
      <ChallengerCard />
      <CourseTopics />
      <SpiritualDisciplines />
      <CBRFormat />
      <HowToConvene />
    </div>
  );
};

export default CBRProgramPage;
